import { ListExportButton } from '../../../components/custom/ListExportButton';
import { MoonstarListActions } from '../../Moonstar/MoonstarListActions';
import { type KpiResponseDto } from '../types';
import { BulkCreateKpiUnitDataButton } from './BulkCreateKpiUnitDataButton';

export const KpiDataActions = ({ kpi }: { kpi: KpiResponseDto }) => {
  return (
    <MoonstarListActions hideCreate>
      <BulkCreateKpiUnitDataButton kpi={kpi} />
      <ListExportButton maxResults={Infinity} />
    </MoonstarListActions>
  );
};
